import i18n from 'i18next';
// import languageDetector from 'i18next-browser-languagedetector';  //for auto detecting user's language uncomment this line
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  // .use(languageDetector) //for auto detecting user's language uncomment this line
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    ns: [
      'translation',
      'navbar',
      'sidebar',
      'login',
      'authorization',
      'common',
      'periodDetails',
      'general',
      'finalVersion',
      'provider',
      'projectTransfer',
      'overhead',
      'avaliablePercentage',
      'considerCollaborator',
      'historic',
      'resourceDonor',
      'allocationPriority',
      'projectPriority',
      'specificAllocation',
      'positionRestriction',
      'roles',
      'extraCollaborator',
      'allocationConstraint',
      'disregardEvents',
    ],
    debug: false,
    lng: 'pt', // for auto detecting user's language uncomment this

    // have a common namespace used around the full app
    defaultNS: 'translation',

    interpolation: {
      escapeValue: true,
    },
  });

export default i18n;
